import React from "react"

import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const SingleImage = graphql`
  query {
    img1: file(relativePath: { eq: "1.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 700) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`

export const Images = () => {
  return (
    <StaticQuery
      query={SingleImage}
      render={data => {
        const img1 = data.img1.childImageSharp.fluid
        return (
          <div>
            <Img fluid={img1} />
          </div>
        )
      }}
    />
  )
}
